/**
 * Nature of champagne
 */
export type ChampagneNature =
  | 'SWEET'
  | 'SEMI_DRY'
  | 'DRY'
  | 'EXTRA_DRY'
  | 'BRUT'
  | 'EXTRA_BRUT'
  | 'BRUT_NATURE';

export const ChampagneNature = {
  Sweet: 'SWEET' as ChampagneNature,
  SemiDry: 'SEMI_DRY' as ChampagneNature,
  Dry: 'DRY' as ChampagneNature,
  ExtraDry: 'EXTRA_DRY' as ChampagneNature,
  Brut: 'BRUT' as ChampagneNature,
  ExtraBrut: 'EXTRA_BRUT' as ChampagneNature,
  BrutNature: 'BRUT_NATURE' as ChampagneNature,
};
